import { $iq, Strophe } from "strophe.js";
import { StrophePlugin } from "./strophe-plugin";

export class StropheLastActivityPlugin extends StrophePlugin {
    private _n = 0;

    public constructor() {
        super('lastactivity');
    }

    public static build() { return new StropheLastActivityPlugin(); }

    public init(conn: any): void {
        super.init(conn);
        Strophe.addNamespace('LAST_ACTIVITY', 'jabber:iq:last');
    }

    public query(jid, options) {
        const c_id = 'lastActivityId' + this._n++;
        const attr = {
            type: 'get',
            id: c_id,
            from: this.connection.jid,
            to: jid
        };
        const lastActivityAttr = { xmlns: Strophe.NS.LAST_ACTIVITY };

        const iq = $iq(attr).c('query', lastActivityAttr);

        const onResponse = options['onResponse'];
        delete options['onResponse'];

        this.connection.addHandler(null, Strophe.NS.LAST_ACTIVITY, 'message', null);
        return this.connection.sendIQ(iq, onResponse);
    }
}
